import { Injectable } from '@angular/core';
import { HighlightEntityType } from '@sb-tools/typescript/enums/highlight-entity-type.enum';
import { EntraIdTenantSimpleDTO } from '@sb-tools/typescript/models/entra-id-tenant-simple.dto';
import { SimpleCommunityModel } from '@sb-tools/typescript/models/simple-community-model.model';

@Injectable({
    providedIn: 'root',
})
export class ParseLogItemByEntityService {
    private patternStr = `\\{(User|Tag|Category|Ticket|Group|Reply|Url|Widget|EntraIdTenant|Community):(([0-9a-fA-F]){8}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){12}|(\\d+)|(https?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)))\\}`;

    parse(logItem): any[] {
        const separator = '--sbSeparator--';
        const logStringWithSeparators = logItem.actionString.replace(new RegExp(this.patternStr, 'gi'), (fullMatch) => {
            return separator + fullMatch + separator;
        });

        let logStringArray = logStringWithSeparators.split(separator);
        logStringArray = logStringArray.map((item) => {
            const itemArray = new RegExp(this.patternStr, 'gi').exec(item);

            if (itemArray && itemArray.length >= 3 && itemArray[1] && itemArray[2]) {
                const entityType = itemArray[1].toLowerCase();
                const entityId = Number(itemArray[2]);
                let mappedItem;

                switch (entityType) {
                    case HighlightEntityType.user: {
                        const user = logItem.includedItems.users.find(
                            (includedUser) => includedUser.id === itemArray[2],
                        );

                        if (user) {
                            mappedItem = {
                                entityType: HighlightEntityType.user,
                                queryParams: {},
                                entityName: user.name || user.email,
                                entity: user,
                            };
                        }

                        break;
                    }

                    case HighlightEntityType.category: {
                        const category = logItem.includedItems.categories.find(
                            (includedCategory) => includedCategory.id === entityId,
                        );

                        if (category) {
                            mappedItem = {
                                entityType: HighlightEntityType.category,
                                queryParams: { categoryIds: entityId },
                                entityName: category.label,
                            };
                        }

                        break;
                    }

                    case HighlightEntityType.tag: {
                        const tag = logItem.includedItems.tags.find((includedTag) => includedTag.id === entityId);

                        if (tag) {
                            mappedItem = {
                                entityType: HighlightEntityType.tag,
                                queryParams: { tagIds: entityId },
                                entityName: tag.text,
                            };
                        }

                        break;
                    }

                    case HighlightEntityType.group: {
                        const group = logItem.includedItems.groups.find(
                            (includedGroup) => includedGroup.id === entityId,
                        );

                        if (group) {
                            mappedItem = {
                                entityType: HighlightEntityType.group,
                                queryParams: {},
                                entityName: group.name,
                                entity: group,
                            };
                        }

                        break;
                    }

                    case HighlightEntityType.ticket: {
                        mappedItem = {
                            entityType: HighlightEntityType.ticket,
                            queryParams: { ticketId: entityId },
                            forwardedToTicketId: entityId,
                        };

                        break;
                    }

                    case HighlightEntityType.reply: {
                        const reply = logItem.includedItems.replies.find(
                            (includedReply) => includedReply.id === entityId,
                        );

                        mappedItem = {
                            entityType: HighlightEntityType.reply,
                            entity: reply,
                        };

                        break;
                    }

                    case HighlightEntityType.url: {
                        mappedItem = {
                            entityType: HighlightEntityType.url,
                            entityName: itemArray[2],
                        };
                        break;
                    }

                    case HighlightEntityType.widget: {
                        const widget = logItem.includedItems.widgets.find(
                            (includedWidget) => includedWidget.id === entityId,
                        );

                        if (widget) {
                            mappedItem = {
                                entityType: HighlightEntityType.widget,
                                entityName: widget.name,
                                entity: widget,
                            };
                        }

                        break;
                    }

                    case HighlightEntityType.entraIdTenant: {
                        const entraIdTenant = logItem.includedItems.entraIdTenants.find(
                            (tenant: EntraIdTenantSimpleDTO) => tenant.tenantId === itemArray[2],
                        );

                        if (entraIdTenant) {
                            mappedItem = {
                                entityType: HighlightEntityType.entraIdTenant,
                                entityName: entraIdTenant.name,
                                entity: entraIdTenant,
                            };
                        }

                        break;
                    }

                    case HighlightEntityType.community: {
                        const community = logItem.includedItems.communities.find(
                            (communityItem: SimpleCommunityModel) => {
                                return communityItem.id === entityId;
                            },
                        );

                        if (community) {
                            mappedItem = {
                                entityType: HighlightEntityType.community,
                                entityName: community.communityDisplayName,
                                entity: community,
                            };
                        }

                        break;
                    }

                    default:
                        break;
                }

                return mappedItem;
            } else {
                return {
                    entityType: HighlightEntityType.text,
                    text: item,
                };
            }
        });

        return logStringArray;
    }
}
